import React from 'react';
import { X, Sun } from 'lucide-react';
import { LOGO } from '../../../constants/site';

const LOGO_FILTER = { filter: 'brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(180deg)' };

export const RelocationModalHeader = ({ area, copy, onClose }) => {
  const headerBg = area === 'outer_banks'
    ? 'bg-gradient-to-br from-[#143160] via-cyan-700 to-[#143160]'
    : 'bg-gradient-to-br from-[#143160] via-[#1E4A86] to-[#143160]';
  return (
    <div className={`p-8 text-center relative overflow-hidden ${headerBg}`}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-4 left-4 w-32 h-32 bg-gold-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-4 right-4 w-24 h-24 bg-sand-50 rounded-full blur-2xl"></div>
      </div>
      <button onClick={onClose} data-testid="relocation-modal-close" className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors">
        <X className="w-6 h-6" />
      </button>
      <div className="relative mb-4">
        <img src={LOGO} alt="Jess Sells East Coast" className="h-16 mx-auto" loading="lazy" decoding="async" style={LOGO_FILTER} />
      </div>
      <div className="inline-flex items-center space-x-2 bg-gold-400 text-[#143160] px-4 py-1 rounded-full text-sm font-bold mb-4">
        <Sun className="w-4 h-4" />
        <span>FREE DOWNLOAD</span>
      </div>
      <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-2">{copy.title}</h3>
      <h4 className="text-xl font-serif font-bold text-gold-400 mb-2">2026 Relocation Guide</h4>
      <p className="text-white/80 text-sm">{copy.subtitle}</p>
    </div>
  );
};
